var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull " },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container " }, [
        _c(
          "div",
          {
            staticClass:
              "row justify-content-center text-left vaillantCont mt-5"
          },
          [
            _c(
              "div",
              { staticClass: "col-md-12 pt-5 pb-5" },
              [
                _vm._v("\n\n        Gentile Professionista,\n        "),
                _c("br"),
                _c("br"),
                _vm._v(
                  '\n        Recentemente è stato pubblicato in Gazzetta Ufficiale il Decreto Legge n. 50/2022 recante "Misure\n        urgenti in materia di politiche energetiche nazionali, produttività delle imprese e attrazione degli\n        investimenti, nonché in materia di politiche sociali e di crisi Ucraina".\n        '
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Le ultime disposizioni inserite nel testo di Legge prevedono un sostanziale cambiamento delle\n        normative sui trasferimenti dei crediti dei Bonus edilizi, una variazione che interessa direttamente le\n        imprese oltre ad istituti bancari ed enti di credito, i quali dovranno recepire ed allinearsi alle nuove\n        disposizioni.\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Per tali ragioni esterne sopra menzionate purtroppo indipendenti dalla nostra volontà, ci vediamo\n        costretti a sospendere temporaneamente i servizi di cessione del credito erogati nella piattaforma\n        "
                ),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v("  CheBonus (www.chebonus.it)  ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" HappyBonus (www.happybonus.it)  ")
                      ])
                    ],
                _vm._v(
                  "\n\n\n        sino a quando non si saranno ripristinate le condizioni per poter\n        ripartire e garantire stabilità e continuità al servizio per i nostri clienti professionisti e privati.\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Il flusso relativo ad Agile Energy sarà anch’esso temporaneamente sospeso, fermo restando che le\n        Pratiche già approvate verranno regolarmente evase alle condizioni preventivamente concordate.\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Per ogni informazione, richiesta o supporto dedicato non esitare a contattarci al numero\n        tel.\n        "
                ),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v("  02.94756.677 ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" 02.94751.001 ")
                      ])
                    ],
                _vm._v(
                  "\n        , sempre disponibili dal lunedì al venerdì negli orari 09:00-13:00 e 14:00-18:00,\n        oppure inviaci una mail a\n        "
                ),
                _vm.brand == "CHEBONUS" ? [_vm._m(0)] : [_vm._m(1)],
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Ringraziandoti per aver scelto di installare i nostri prodotti ed in attesa di ripristino del programma\n        ufficiale di sconto in fattura e cessione del credito\n        "
                ),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v(" CheBonus, Vaillant  ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" HappyBonus, Hermann Saunier Duval  ")
                      ])
                    ],
                _vm._v("\n\n\n        ti augura Buon lavoro.\n        "),
                _c("br"),
                _c("br"),
                _vm._v("\n        Il tuo team\n        "),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v(" Vaillant CheBonus ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v("  Hermann Saunier Duval HappyBonus ")
                      ])
                    ],
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _vm._m(2)
              ],
              2
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", { staticClass: "green" }, [
      _c(
        "a",
        {
          staticClass: "green",
          attrs: { href: "mailto:info@chebonus.it", target: "_blank" }
        },
        [_vm._v(" info@chebonus.it ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", { staticClass: "green" }, [
      _c(
        "a",
        {
          staticClass: "red",
          attrs: { href: "info@happybonus.it", target: "_blank" }
        },
        [_vm._v(" info@happybonus.it ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v(
        "\n          Questa comunicazione è strettamente confidenziale.\n          "
      ),
      _c("br"),
      _vm._v(
        "E’ vietata qualsiasi divulgazione, riproduzione, distribuzione o uso del contenuto.\n        "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f06c4c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f06c4c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowSettings/index.vue
// module id = null
// module chunks = 